import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65da1982&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=65da1982&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65da1982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65da1982')) {
      api.createRecord('65da1982', component.options)
    } else {
      api.reload('65da1982', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=65da1982&scoped=true", function () {
      api.rerender('65da1982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjSteps/index.vue"
export default component.exports